const KEY = 'ORGANIZATION';

export { KEY };
